export default "__VITE_ASSET__BrL9$Rp___"